var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.is_total != 1 && _vm.searchData.tag_type == 2
        ? [
            _c(
              "el-card",
              { staticClass: "box-card" },
              [
                _c(
                  "div",
                  { staticClass: "order-info-tab" },
                  [
                    _c(
                      "el-tabs",
                      {
                        model: {
                          value: _vm.activeName,
                          callback: function ($$v) {
                            _vm.activeName = $$v
                          },
                          expression: "activeName",
                        },
                      },
                      [
                        _c("el-tab-pane", {
                          attrs: { label: "卡类型信息", name: "1" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { staticClass: "my-row", attrs: { gutter: 20 } },
                  _vm._l(_vm.cardInfoList, function (col) {
                    return _c(
                      "el-col",
                      { key: col.value, attrs: { span: 4 } },
                      [
                        _c(
                          "div",
                          { staticClass: "content" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(_vm._s(col.label)),
                            ]),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  disabled: !col.tooltip,
                                  content: String(
                                    col.formatter
                                      ? col.formatter()
                                      : _vm.cardInfo[col.value]
                                  ),
                                  placement: "top",
                                },
                              },
                              [
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        col.formatter
                                          ? col.formatter()
                                          : _vm.cardInfo[col.value]
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-card",
              { staticClass: "gross-card", staticStyle: { margin: "10px 0" } },
              [
                _c(
                  "div",
                  { staticClass: "top-btn" },
                  [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("订单金额："),
                    ]),
                    _c(
                      "el-radio-group",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.loadData("update_gross")
                          },
                        },
                        model: {
                          value: _vm.searchData.gross_profit_type,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchData, "gross_profit_type", $$v)
                          },
                          expression: "searchData.gross_profit_type",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: "2" } }, [
                          _vm._v("按已售金额"),
                        ]),
                        _c("el-radio", { attrs: { label: "1" } }, [
                          _vm._v("按实收"),
                        ]),
                        _c("el-radio", { attrs: { label: "0" } }, [
                          _vm._v("按应收"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-tabs",
                  {
                    model: {
                      value: _vm.activeName,
                      callback: function ($$v) {
                        _vm.activeName = $$v
                      },
                      expression: "activeName",
                    },
                  },
                  [
                    _c("el-tab-pane", {
                      attrs: { label: "卡类型留存率", name: "1" },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form",
                  { staticClass: "form", attrs: { inline: "", size: "small" } },
                  _vm._l(_vm.grossList, function (row, rowIndex) {
                    return _c(
                      "el-row",
                      { key: rowIndex, attrs: { gutter: 20 } },
                      _vm._l(row, function (col, colIndex) {
                        return _c(
                          "el-col",
                          { key: colIndex, attrs: { span: 4 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: col.label } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      col.formatter
                                        ? col.formatter()
                                        : _vm.cardInfo[col.value]
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _c(
        "el-card",
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.changeTab },
              model: {
                value: _vm.activeNameChart,
                callback: function ($$v) {
                  _vm.activeNameChart = $$v
                },
                expression: "activeNameChart",
              },
            },
            _vm._l(_vm.tabList, function (tab) {
              return _c("el-tab-pane", {
                key: tab.name,
                attrs: { label: tab.label, name: tab.name },
              })
            }),
            1
          ),
          _vm.activeNameChart === "1"
            ? _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("div", {
                        ref: "datascren_order",
                        staticStyle: { width: "100%", height: "350px" },
                        attrs: { id: "datascren_order" },
                      }),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            border: "",
                            "header-cell-style": {
                              background: "#F1F1F1",
                              color: "#333333",
                            },
                            data: _vm.orderTypeList,
                            "tooltip-effect": "dark",
                          },
                        },
                        _vm._l(_vm.columns("order"), function (col) {
                          return _c("el-table-column", {
                            key: col.key,
                            attrs: {
                              label: col.label,
                              prop: col.prop,
                              formatter: col.formatter || null,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("div", {
                        ref: "datascren_business",
                        staticStyle: { width: "100%", height: "350px" },
                        attrs: { id: "datascren_business" },
                      }),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            border: "",
                            "header-cell-style": {
                              background: "#F1F1F1",
                              color: "#333333",
                            },
                            data: _vm.businessTypeList,
                            "tooltip-effect": "dark",
                          },
                        },
                        _vm._l(_vm.columns("business"), function (col) {
                          return _c("el-table-column", {
                            key: col.key,
                            attrs: {
                              label: col.label,
                              prop: col.prop,
                              formatter: col.formatter || null,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("div", {
                        ref: "datascren_consume",
                        staticStyle: { width: "100%", height: "350px" },
                        attrs: { id: "datascren_consume" },
                      }),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            border: "",
                            "header-cell-style": {
                              background: "#F1F1F1",
                              color: "#333333",
                            },
                            data: _vm.consumeScenarioList,
                            "tooltip-effect": "dark",
                          },
                        },
                        _vm._l(_vm.columns("consume"), function (col) {
                          return _c("el-table-column", {
                            key: col.key,
                            attrs: {
                              label: col.label,
                              prop: col.prop,
                              formatter: col.formatter || null,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.activeNameChart === "2"
            ? [
                _c("div", {
                  ref: "datascren_category_cost",
                  staticStyle: { width: "100%", height: "350px" },
                  attrs: { id: "datascren_category_cost" },
                }),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-end",
                      margin: "10px 0",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.onClickCategoryExport },
                      },
                      [_vm._v("导出")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      border: "",
                      "header-cell-style": {
                        background: "#F1F1F1",
                        color: "#333333",
                      },
                      data: _vm.categoryCostList,
                      "row-style": function (ref) {
                        var row = ref.row

                        return row.category_name === "总计"
                          ? { fontWeight: "bold", color: "#000" }
                          : {}
                      },
                      "tooltip-effect": "dark",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "菜单名称（ID）", prop: "category_name" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      placement: "top",
                                      disabled:
                                        scope.row.category_name === "总计",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            "别名：" + _vm._s(scope.row.alias)
                                          ),
                                        ]),
                                        _c("div", [
                                          _vm._v(
                                            "备注：" + _vm._s(scope.row.note)
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c("div", [
                                      _vm._v(_vm._s(scope.row.category_name)),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2073522332
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "订单类型", prop: "name" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "消费点数", prop: "amount" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "消费占比", prop: "occupancy" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " + _vm._s(scope.row.occupancy + "%") + " "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4035996204
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "成本", prop: "actual_cost_amount_a0" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "成本率", prop: "cost_occupancy" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(scope.row.cost_occupancy + "%") +
                                    " "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4221060248
                      ),
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "10px",
                      "text-align": "right",
                    },
                  },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        layout: "total, prev, pager, next, jumper",
                        "current-page": _vm.categoryCostPaging.page,
                        "page-size": _vm.categoryCostPaging.page_size,
                        total: _vm.categoryCostPaging.totalCount,
                      },
                      on: { "current-change": _vm.changeCategoryCostPage },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }